module.exports = __webpack_public_path__ + "media/images/dashcore/logo-light-096fe1a98334639fecdfc83ea3e08ff0.png";